module.exports = require("core-js/library/fn/object/create");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/create.js
// module id = 1368
// module chunks = 0